import {Dispatch} from 'redux';
import {
  POCTool,
  POCToolSummaryWebPortal,
  SuperPOCTool,
  Category,
} from '../../models/IPOCToolWebPortal';
import {
  getPOCToolSummaries,
  getPOCToolById,
  getMiniPOCToolById,
  getContentByMiniToolId,
} from '../../api/POCWebPortalAPI/POCToolsCalls';

export const FETCHING_POCTOOL_SUMMARY_WEBPORTAL =
  'FETCHING_POCTOOL_SUMMARY_WEBPORTAL';
export const SET_POCTOOL_SUMMARY_WEBPORTAL_FULFILLED =
  'SET_POCTOOL_SUMMARY_WEBPORTAL_FULFILLED';
export const SET_POCTOOL_SUMMARY_WEBPORTAL_FAILED =
  'SET_POCTOOL_SUMMARY_WEBPORTAL_FAILED';
export const FETCHING_POCTOOL_BY_ID_WEBPORTAL =
  'FETCHING_POCTOOL_BY_ID_WEBPORTAL';
export const FETCHING_MINIPOCTOOL_BY_ID_WEBPORTAL =
  'FETCHING_MINIPOCTOOL_BY_ID_WEBPORTAL';
export const FETCHING_CONTENT_BY_MINITOOL_ID_WEBPORTAL =
  'FETCHING_MINIPOCTOOL_BY_ID_WEBPORTAL';
export const SET_POCTOOL_BY_ID_WEBPORTAL_FULFILLED =
  'SET_POCTOOL_BY_ID_WEBPORTAL_FULFILLED';
export const SET_MINIPOCTOOL_BY_ID_WEBPORTAL_FULFILLED =
  'SET_MINIPOCTOOL_BY_ID_WEBPORTAL_FULFILLED';
export const SET_CONTENT_BY_MINITOOL_ID_WEBPORTAL_FULFILLED =
  'SET_CONTENT_BY_MINITOOL_ID_WEBPORTAL_FULFILLED';
export const SET_POCTOOL_BY_ID_WEBPORTAL_FAILED =
  'SET_POCTOOL_BY_ID_WEBPORTAL_FAILED';
export const SET_MINIPOCTOOL_BY_ID_WEBPORTAL_FAILED =
  'SET_MINIPOCTOOL_BY_ID_WEBPORTAL_FAILED';
export const SET_CONTENT_BY_MINITOOL_ID_WEBPORTAL_FAILED =
  'SET_CONTENT_BY_MINITOOL_ID_WEBPORTAL_FAILED';

export interface FetchingPOCToolSummaryWebPortalAction {
  type: 'FETCHING_POCTOOL_SUMMARY_WEBPORTAL';
}
export interface SetPOCToolSummaryWebPortalActionFulfilled {
  type: 'SET_POCTOOL_SUMMARY_WEBPORTAL_FULFILLED';
  summaries: POCToolSummaryWebPortal[];
}
export interface SetPOCToolSummaryWebPortalActionFailed {
  type: 'SET_POCTOOL_SUMMARY_WEBPORTAL_FAILED';
  error: string;
}
export interface FetchingPOCToolByIDWebPortalAction {
  type: 'FETCHING_POCTOOL_BY_ID_WEBPORTAL';
}
export interface FetchingMiniPOCToolByIDWebPortalAction {
  type: 'FETCHING_MINIPOCTOOL_BY_ID_WEBPORTAL';
}
export interface FetchingContentByMiniTollIdWebPortalAction {
  type: 'FETCHING_CONTENT_BY_MINITOOL_ID_WEBPORTAL';
}
export interface SetPOCToolByIDWebPortalActionFulfilled {
  type: 'SET_POCTOOL_BY_ID_WEBPORTAL_FULFILLED';
  pocTool: POCTool;
}
export interface SetMiniPOCToolByIDWebPortalActionFulfilled {
  type: 'SET_MINIPOCTOOL_BY_ID_WEBPORTAL_FULFILLED';
  superPocTool: SuperPOCTool;
}
export interface SetContentByMiniTollIDWebPortalActionFulfilled {
  type: 'SET_CONTENT_BY_MINITOOL_ID_WEBPORTAL_FULFILLED';
  content: [Category];
}
export interface SetPOCToolByIDWebPortalActionFailed {
  type: 'SET_POCTOOL_BY_ID_WEBPORTAL_FAILED';
  error: string;
}
export interface SetMiniPOCToolByIDWebPortalActionFailed {
  type: 'SET_MINIPOCTOOL_BY_ID_WEBPORTAL_FAILED';
  error: string;
}
export interface SetContentByMiniTollIDWebPortalActionFailed {
  type: 'SET_CONTENT_BY_MINITOOL_ID_WEBPORTAL_FAILED';
  error: string;
}

export type KnownAction =
  | FetchingPOCToolSummaryWebPortalAction
  | SetPOCToolSummaryWebPortalActionFulfilled
  | SetPOCToolSummaryWebPortalActionFailed
  | FetchingPOCToolByIDWebPortalAction
  | FetchingMiniPOCToolByIDWebPortalAction
  | FetchingContentByMiniTollIdWebPortalAction
  | SetPOCToolByIDWebPortalActionFulfilled
  | SetMiniPOCToolByIDWebPortalActionFulfilled
  | SetPOCToolByIDWebPortalActionFailed
  | SetContentByMiniTollIDWebPortalActionFulfilled
  | SetMiniPOCToolByIDWebPortalActionFailed
  | SetContentByMiniTollIDWebPortalActionFailed;

export const actionCreators = {
  getPOCToolSummaries: () => {
    return async (dispatch: Dispatch<KnownAction>) => {
      dispatch({
        type: FETCHING_POCTOOL_SUMMARY_WEBPORTAL,
      });
      try {
        const json = await getPOCToolSummaries();
        dispatch({
          type: SET_POCTOOL_SUMMARY_WEBPORTAL_FULFILLED,
          summaries: json,
        });
      } catch (error: any) {
        dispatch({
          type: SET_POCTOOL_SUMMARY_WEBPORTAL_FAILED,
          error: error.message,
        });
      }
    };
  },
  getPOCToolById: (id: string) => {
    return async (dispatch: Dispatch<KnownAction>) => {
      dispatch({
        type: FETCHING_POCTOOL_BY_ID_WEBPORTAL,
      });
      try {
        const json = await getPOCToolById(id);
        dispatch({
          type: SET_POCTOOL_BY_ID_WEBPORTAL_FULFILLED,
          pocTool: json,
        });
      } catch (error: any) {
        dispatch({
          type: SET_POCTOOL_BY_ID_WEBPORTAL_FAILED,
          error: error.message,
        });
      }
    };
  },
  getMiniPOCToolById: (id: string) => {
    return async (dispatch: Dispatch<KnownAction>) => {
      dispatch({
        type: FETCHING_MINIPOCTOOL_BY_ID_WEBPORTAL,
      });
      try {
        const json = await getMiniPOCToolById(id);
        dispatch({
          type: SET_MINIPOCTOOL_BY_ID_WEBPORTAL_FULFILLED,
          superPocTool: json,
        });
      } catch (error: any) {
        dispatch({
          type: SET_MINIPOCTOOL_BY_ID_WEBPORTAL_FAILED,
          error: error.message,
        });
      }
    };
  },
  getMiniToolContent: (POCToolId, minitoolId) => {
    return async (dispatch: Dispatch<KnownAction>) => {
      dispatch({
        type: FETCHING_CONTENT_BY_MINITOOL_ID_WEBPORTAL,
      });
      try {
        const json = await getContentByMiniToolId(POCToolId, minitoolId);
        dispatch({
          type: SET_CONTENT_BY_MINITOOL_ID_WEBPORTAL_FULFILLED,
          content: json,
        });
      } catch (error: any) {
        dispatch({
          type: SET_CONTENT_BY_MINITOOL_ID_WEBPORTAL_FAILED,
          error: error.message,
        });
      }
    };
  },
};
